<mat-checkbox [checked]="params.value" [formControl]="checkbox" style="transform: scale(0.8)" (click)="stop($event)"></mat-checkbox>